import apiConfig from 'src/integration/config/apiConfig';
import useQueryKey from 'src/toolkit/utils/useQueryKey';
import { useStore } from 'src/integration/store/store';
import useReactQueryJava from 'src/integration/api/useReactQueryJava';
import useErrorHandling from 'src/toolkit/utils/useErrorHandling';

const useFetchBattery = () => {
  const { batteryStore, settingsStore } = useStore();
  const { setBatteryData } = batteryStore;
  const { selectedSiteId, selectedDate } = settingsStore;
  const { logoutOnError } = useErrorHandling();

  const response = useReactQueryJava<SimpleObject, SimpleObject>({
    endpoint: apiConfig.api.endpointsJava.battery,
    queryKey: useQueryKey('battery', [selectedDate, selectedSiteId?.toString()]),
    method: 'GET',
    queryParams: {
      date: selectedDate,
      siteId: selectedSiteId,
    },
    opts: {
      enabled: !!selectedSiteId,
      refetchOnWindowFocus: false,
      onSuccess: (data: any[]) => {
        setBatteryData(data);
      },
    },
  });

  return {
    ...response,
  };
};

export default useFetchBattery;
